export { default } from './UserDetail';
